module.exports = __webpack_public_path__ + "img/en-plugin-btn.1ab84eef.png";